import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CategoryPage from "@/pages/CategoryPage";
import BrochurePage from "@/pages/BrochurePage";
import WhatsAppFab from "@/components/WhatsAppFab";

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const selectors = [
        "#emergent-badge",
        'a[href*="emergent-badge"]',
        'a[href*="app.emergent.sh"]',
        "[data-emergent-badge]",
      ];
      selectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => el.remove());
      });
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/metal" element={<CategoryPage slug="metal" />} />
            <Route path="/urban" element={<CategoryPage slug="urban" />} />
            <Route
              path="/plastics"
              element={<CategoryPage slug="plastics" />}
            />
            <Route
              path="/packaging"
              element={<CategoryPage slug="packaging" />}
            />
            <Route
              path="/lighting"
              element={<CategoryPage slug="lighting" />}
            />
            <Route
              path="/catalogs/urban"
              element={<BrochurePage slug="urban" />}
            />
            <Route
              path="/catalogs/lighting"
              element={<BrochurePage slug="lighting" />}
            />
            <Route
              path="/catalogs/heating"
              element={<BrochurePage slug="heating" />}
            />
            <Route path="*" element={<Home />} />
          </Routes>
          <WhatsAppFab />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
